import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './assets/styles/global.styl';
import { App } from './app/App';
import { initI18n } from './app/i18n';
import { installChunkRecovery } from './shared/lib/chunkRecovery';

initI18n();
installChunkRecovery();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
